module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('big', [_vm._v("A")]), _vm._v("nna never went to the "), _c('em', [_vm._v("hrad")]), _vm._v(", the great walled castle on the western hill overlooking Prague. It hunched just across the Vltava River, a world away. Nor did she go to the great cathedral standing guard over the castle lest she encounter the dread archbishop. Zybnek. The burner of books.")], 1), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Her grandfather had warned his little clutch of scholars and translators too, chastising them for their careless zeal.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("And wasn’t he the one to talk!")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Anna glanced at the castle and the cathedral spires of Saint Vitus standing sentinel behind it. She shivered even in the summer heat. But she would not think about the monster on the hill today. Not on a day when the sunlight flung dancing diamonds on the water and no smell of burning tainted the air. Not on a day when the birds wheeled in joyful circles above the river, their wing tips flirting with cloud pillows.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Not on a day when she was meeting Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("She turned her back to the castle and looked downriver. In the distance she could make out a camp of some sort, likely pilgrims traversing Christendom to any number of shrines—Jerusalem the holiest—in penance. That was what sinners did, sinners who could not afford to purchase expiation from the Church.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("From the town sprawled on her left a familiar figure approached, but not the figure for whom she was looking. “Master Jerome! I thought Martin was coming,” she said, feeling her face redden, her disappointment all too obvious.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Martin is otherwise occupied, it seems,” the gray-haired master said wearily. He handed her the bag that held the translated texts to be copied at the next meeting. “Thank you for doing my laundry, mistress,” he said loudly.")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Anna took the university master’s “laundry” and was about to bid him good afternoon when she heard rapid footsteps approaching from the other end of the bridge. She turned to see a lone figure running toward them as though the devil gave chase. Seconds later Martin joined them beneath the sheltering shade of the gate tower. He was gasping for breath and his face was flushed and his black hair fell in an unruly wave across his forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“I’m sorry, Master Jerome. I was detained—”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“You didn’t have time to put on your cap?” Anna pushed Martin’s hair away from his forehead with her hand, a ruse to caress his face.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“I lost it. But in good cause,” he said, breathing heavily. Winking at Anna, he sucked in air and lowered his voice to an almost whisper. “I’ll show you at the meeting— No. I can’t wait. I have to show it to you now.” He drew them deeper into the shadowy hollow of the tower gate and pulled from his plain brown student’s doublet a black velvet packet. It was marked with a Jerusalem cross.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Put that away,” Jerome hissed. “How did you come by it?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Is that what I think it is?” Anna asked, not remembering to lower her voice. “I’ve never even seen one. May I see it?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Alarm showed in Jerome’s face. “Not here, Martin! You didn’t—”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“No, we didn’t hurt the pardoner, didn’t even scruff him up—well maybe a couple of … you know, smallish bruises. He was just setting up shop outside Saint Vitus Cathedral. Stasik kicked him in his shins, and the pardoner dropped his ‘grace notes.’ While he was nursing his shins—he even curses in Latin—we took off down Crooked Alley. Stasik made for New Town. I headed for Old Town. As easy as taking pennies from a blind beggar.”")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Martin was grinning broadly as he darted glances across the bridge to assure himself he had not been followed. As was usual in the heat of the mid-afternoon, the bridge was deserted except for the woodsman who was exiting on the other end and a beggar who sat at the gate on the other side of the river.")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("At the mention of her grandfather’s name, some of Martin’s bravado vanished.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Jerome’s gray eyebrows bunched together in a scowl. “I don’t think such exploits will weigh in your favor when the illuminator seeks a husband for his granddaughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("He was nothing if not direct. Not now. Not ever.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Martin’s smile vanished quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“I want to see one, Master Jerome,” Anna said. “All my life I’ve heard my grandfather and you ranting about the pope’s sale of indulgences to finance his wars, as though they were written by the devil’s own hand, and I’ve never even seen one.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The old man looked at her and shook his head. “You’re as stupid as your suitor. You deserve each other,” he said. “Just pray I’m not arrested before I can dispose of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Please, Master Jerome. Bring them to the next meeting. Let us all see what it is we are risking so much to rid the world of. Then you can burn them. We’ll have a little bonfire of our own.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("She smiled at him, her wheedling smile, the same smile she had used from childhood on her grandfather to push him through the occasional cloud of melancholy that sometimes descended upon their little house in the town square. “Please. A wee little bonfire of our own. Sweet revenge. To rally our troops.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Methinks our troops have a surfeit of rallying.” That was his parting jibe, but his scowl had lightened somewhat.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“He’ll bring them,” Anna said as the old master walked away.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Of course he will. How could he resist such pretty pouting? I know I couldn’t.” Martin reached up and touched her lips with the tip of his finger, bent forward as if to kiss her.")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Aye,” he said, letting his arms drop to his side. “Your grandfather. And therein lies the curdle in the coddle.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Now it was his turn to pout. She resisted the urge to kiss the pout away.")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("His lips were full, and round, and cherry ripe.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Don’t be silly. He likes you, Martin. He just thinks you’re a little headstrong. He thinks nobody can take care of me the way he does.”")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("He glanced up at the castle on the hill, his eyes widening in mock terror. “Don’t tell me I’ll be taking a blue blood to bed as wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“My grandmother was lesser nobility. But we climbed down from that hill long ago. If you take me, you will be taking a humble artisan’s granddaughter to wife—with a dowry to match.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Well, that’s a relief. Not the dowry part, maybe.” He grinned. “Did you know her?”")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Did you know your parents?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("She shook her head. “My mother died when I was born. I was scarcely old enough to walk when my father died.”")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("She wished he hadn’t brought it up. She didn’t like thinking about it, but she supposed if he were to be her husband he was entitled to know her history.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“He died in the Lollard cause. Killed by the bishop’s soldiers. Kathryn died in a peasant rebellion when they burned her manor house. The Church blamed the Lollards for the uprising and killed everyone they could find. My grandfather and I escaped from England to the Continent.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Martin whistled low. “So you come from a royal line of heretics. And your grandfather continues in the cause. A wonder that he never returned to England. Old Jerome says in England some of the nobility have embraced the idea of reform. It might be easier there.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“He says there is nothing for him there but painful memories. Why should we want to leave Prague? We have been happy here. He has his art and his friends from the university. I have friends here too.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("She tried to make her tone teasing, playful, but talk of so much death had spoiled the mood. As they neared the square, he slid his arm around her waist, pulling her back toward the cover of the twisting street. She shook her head and pointed to the great two-faced astronomical clock.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Hurry, Martin. Look. It’s almost three o’clock. My grandfather will be worried, and he gets cross when he’s worried. Besides, I still have to prepare his supper. It will have to be fish now; there’s no time for anything else.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The sun did not reemerge from behind the cloud, and suddenly it seemed to Anna that the joy—like the sunlight—had drained from the day.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Don’t walk with me the rest of the way. You do not want him to think you’re the reason that he must have fish and not a nicely roasted joint for supper.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“No. I want him in a good mood for what I have to ask him,” he said. “Why shouldn’t I ask him now? Before he finds out about the fish?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Anna looked across the street at their little town house of baked brick and half-timbers with its pretty carved door standing open to the square. By now her grandfather would have finished his day’s work, cleaned his brushes, neatly stacked his paint pots along the window ledge, and would be napping in his chair.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Not now, Martin. Give me a chance to prepare him.”")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Just a few days more, I promise.” She reached up again and brushed his hair away from his eyes—eyes that flashed his frustration as she turned to leave.")]), _vm._v(" "), _vm._m(18)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter01"
    }
  }), _vm._v("ONE")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "46",
      "src": "images/flower1.jpg",
      "width": "160"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "author1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RAGUE")]), _vm._v(", B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHEMIA")]), _c('br'), _vm._v("J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ULY")]), _vm._v(" 1412")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "normal5"
  }, [_c('em', [_vm._v("The Avon to the Severn runs,"), _c('br'), _vm._v("The Severn to the sea,"), _c('br'), _vm._v("And Wy cliffe’s dust shall spread abroad,"), _c('br'), _vm._v("Wide as the waters he.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "normal6"
  }, [_vm._v("—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FROM AN ADDRESS BY")]), _c('br'), _vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANIEL")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EBSTER")]), _vm._v(" (1849)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Anna attended mass at Týn Church or met with the rest of Prague’s dissidents at Bethlehem Chapel. After Zybnek’s great bonfire of the Wycliffe tracts and the translated gospels, Lollard texts the Church called them, heretical texts because they charged papal corruption and challenged priestly authority, Hus had warned his growing congregation, “The day will surely come when "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("Rome’s prelates are not content to burn the Word but seek out for their fires those who would bring the Word to the people. We must pray for the strength to stand for our beliefs. We must fasten our courage against such a day.”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("After all, it was he, her own grandfather, Finn the Illuminator, Finn the Lollard scribe, who, along with Master Jerome, had started Prague’s secret enterprise to disseminate the banned translations. As a young exchange student, Jerome had returned to his Czech homeland from Oxford, bringing with him the Lollard texts. "), _c('em', [_vm._v("The Trialogus")]), _vm._v(" and "), _c('em', [_vm._v("De Ecclesia")]), _vm._v(" of John Wycliffe. Banned in England, they’d found new life at the new university at Prague. Its rector, Jan Hus, had translated the condemned texts, along with a good portion of the gospels, into Czech. And for years, right under the archbishop’s nose, her own grandfather, a refugee from a long-ago brush with English Lollardy, had gathered a wellspring of university dissidents into his little town house, where they copied the banned pages.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Who knew the carp in the river had eyes and ears? Or that the woodcutter hauling his cart across the stone bridge might be a spy for the archbishop? But she bit back her sarcasm. She would not belittle him for his excess of caution. She had too much respect for all he had accomplished.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("You’d be more likely to give pennies to a blind beggar")]), _vm._v(", Anna thought, but kept silent, letting him enjoy his moment.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Anna could see from Jerome’s scowl that he was not impressed. “Fool, do "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("you want to bring the archbishop down on our heads? Wait till Finn hears what you’ve done. This is not our way.” He snatched the little packet of papal indulgences and hid them quickly in his shirt.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("She pushed him away. “Not here, Martin. Somebody will see. Besides, we are not betrothed. Not yet. Not until D"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("de"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/c.jpg",
      "width": "7"
    }
  }), _vm._v("ek gives his consent.”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("“I don’t think he likes me overmuch,” Martin said.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Well, for my coin, putting you in the middle of a twice-weekly meeting of heretics is not taking very good care. Why do you call him D"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("de"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/c.jpg",
      "width": "7"
    }
  }), _vm._v("ek, anyway? I thought both of you were English?”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("She reached for his hand. “Come on. You can walk me back to my door,” she said, leading him. “I have called him that since we first came here, when I was a child. Besides, I don’t feel English, even though my grandmother was from England too. She was a grand lady and lived in a manor house. But I wouldn’t want to live there. I can’t imagine living anywhere but here with you and D"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("de"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/c.jpg",
      "width": "7"
    }
  }), _vm._v("ek.”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“My English grandmother? Only her name, Kathryn. She was not D"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("de"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/c.jpg",
      "width": "7"
    }
  }), _vm._v("ek’s wife. His wife was named Rebekka, and she died giving birth to my mother. Kathryn was my father’s mother, but she and D"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("de"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/c.jpg",
      "width": "7"
    }
  }), _vm._v("ek knew each other. I think they were lovers. Though he seldom speaks of her, I think he loved her very much. She died when I was hardly more than a babe. I have this faint memory—more dream than memory—of her singing to me. She called me ‘poppet’ or ‘moppet’ or something. And she took me to see D"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("de"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/c.jpg",
      "width": "7"
    }
  }), _vm._v("ek. He was shut up in some kind of castle.”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Anna looked up at the "), _c('i', [_vm._v("hrad")]), _vm._v(" and shivered. The sun had gone behind one of the pillow clouds, turning its underbelly gray. The castle looked even more menacing under the sunless sky. “A castle on a hill like that but more … fortified. ‘Castle Prison,’ they called it. Whenever I think of England, I think of that awful place.”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("“In battle?”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("He frowned. “That’s what you said last week, Anna. How much longer do you want me to wait?”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_c('em', [_vm._v("Now I’ll have both of them angry. In trying to please both, I’ve pleased neither.")]), _vm._v(" She sighed as she hitched up her skirt so she could make it to the fishmonger before he closed shop for the day.")])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1800011b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 81
// module chunks = 0